
import React, {  useContext, useState, useEffect } from 'react';
import { fetchpdf } from '../../data/Contentapi';
import { MyContext } from '../../globalContext';
import { getConfig } from "./../../loadconfig";
import PrintIcon from '@mui/icons-material/Print';
import { useTranslation } from 'react-i18next';
import trackClick from '../../data/ClickTracking';
import { commonPublishEvent } from '../../utils/PublishEventMethod';
import {CircularProgress } from '@mui/material';


const ProviderDetailsDownload = () => {
  const [showDownloadProgress, setShowDownloadProgress] = useState(false);
  const { languageData, selectedForDetails, jwtToken, searchCriteria, address, getSessionIdData } = useContext(MyContext);  
    const [pdfDetails, setPdfDetails] = useState("");
    const { t } = useTranslation();
    const mycontext = useContext(MyContext);
    let config = getConfig();


useEffect(() => {  
  setPdfDetails({...selectedForDetails, language: languageData});

}, [languageData]);



  const downloadPdf = async (event) => {
    try {
      event.preventDefault();
      setShowDownloadProgress(true);
     
      // Replace with your service URL
      const response = await fetchpdf(config.PROVIDER_DETAIL_DOWNLOAD_URL, pdfDetails,mycontext);
      console.log('Response got');
      const blob = response; //await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'providerDetails.pdf'; // Set the file name
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setShowDownloadProgress(false);
      trackClick("Provider Search", "Download Details", selectedForDetails.alternateIDNumber, languageData);
    } catch (error) {
      setShowDownloadProgress(false);
      console.error('Error downloading the PDF:', error);
    }

       
    const eventData = {
      "Locale": languageData,
      "ReCaptcha response" : { "error-codes" : [ { "value" : "invalid-keys" } ] }, 
      "ReCaptcha version":"V3",
      "Zip Code": address.zipCode,
      "Product Code": searchCriteria.productCodeList,
      "Provider Type List": searchCriteria.providerTypeList,
      "Search String": searchCriteria.searchDisplayString,
      "Code Group List": searchCriteria.codeGroupList,
      "Client Account Number List": searchCriteria.clientAccountNumberList
}
 await commonPublishEvent("Provider Search Printer Friendly", eventData, jwtToken, getSessionIdData())
  };
 
  return (
    <div className="linkBoxResp"> 
    < PrintIcon style={{ verticalAlign: "middle", color: "#007839" }} />  <a href="#" className="results-link"  onClick={downloadPdf} > {t(`printerfriendly`)}</a>
    <CircularProgress data-testid='loading-circle' color="primary" style={{ verticalAlign: "middle", width: '20px', height: '20px', marginLeft:"5px", display: !showDownloadProgress && "none" }}  /></div>
  );
};
 
export default ProviderDetailsDownload;